import { Link } from 'gatsby';
import styled from 'styled-components';


export const InlineLink = styled.a`
  color: #633453;
  text-decoration-color: rgba(99, 52, 83, 0.45);
  text-decoration-thickness: 1px;
  text-underline-offset: 0.22em;

  transition:
    color 150ms ease,
    text-decoration-color 150ms ease;

  &:hover {
    color: #351629;
    text-decoration-color: currentColor;
  }

  &:focus-visible {
    outline: 2px solid #633453;
    outline-offset: 4px;
  }
`;
export const InlineInternalLink = styled(Link)`
  color: #633453;
  text-decoration-color: rgba(99, 52, 83, 0.45);
  text-decoration-thickness: 1px;
  text-underline-offset: 0.22em;

  transition:
    color 150ms ease,
    text-decoration-color 150ms ease;

  &:hover {
    color: #351629;
    text-decoration-color: currentColor;
  }

  &:focus-visible {
    outline: 2px solid #633453;
    outline-offset: 4px;
  }
`;

export const SelectedLinksSection = styled.section`
  max-width: 850px;
  margin-top: 2rem;
`;

export const SelectedLinksTitle = styled.h2`
  margin: 0 0 1.25rem;

  color: #70445f;
  font-family: 'Cinzel', serif;
  font-size: 0.8rem;
  font-weight: normal;
  letter-spacing: 0.14em;
  text-transform: uppercase;
`;

export const SelectedLinksList = styled.ol`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  margin: 0;
  padding: 0;
  list-style: none;
  counter-reset: selected-links;
`;

export const SelectedLinksItem = styled.li`
  margin: 0;
  counter-increment: selected-links;
`;

export const SelectedLink = styled.a`
  display: grid;
  grid-template-columns: 2.25rem minmax(0, 1fr) auto;
  gap: 0.8rem;
  align-items: baseline;

  padding: 0.25rem 0;

  color: #292529;
  font-family: 'Cormorant', serif;
  font-size: clamp(1.1rem, 1.6vw, 1.35rem);
  line-height: 1.35;
  text-decoration: none;

  transition:
    color 160ms ease,
    transform 160ms ease;

  &::before {
    content: counter(selected-links, decimal-leading-zero);
    color: #a68b9c;
    font-family: 'Cinzel', serif;
    font-size: 0.65rem;
    letter-spacing: 0.05em;
  }

  &::after {
    content: '↗';
    color: #a68b9c;
    font-family: sans-serif;
    font-size: 0.8rem;
    opacity: 0;
    transform: translate(-4px, 3px);

    transition:
      opacity 160ms ease,
      transform 160ms ease;
  }

  &:hover {
    color: #633453;
    transform: translateX(4px);
  }

  &:hover::after {
    opacity: 1;
    transform: translate(0, 0);
  }

  &:focus-visible {
    outline: 2px solid #633453;
    outline-offset: 4px;
  }

  @media (max-width: 575px) {
    grid-template-columns: 1.8rem minmax(0, 1fr) auto;
    gap: 0.55rem;
  }
`;